import buyerImage1 from '../../../assets/images/about/buyers/albertsons.png';
import buyerImage2 from '../../../assets/images/about/buyers/aldi.png';
import buyerImage3 from '../../../assets/images/about/buyers/earthFare.png';
import buyerImage4 from '../../../assets/images/about/buyers/hungryroot.png';
import buyerImage5 from '../../../assets/images/about/buyers/infra.png';
import buyerImage6 from '../../../assets/images/about/buyers/kimberton.png';
import buyerImage7 from '../../../assets/images/about/buyers/kroger.png';
import buyerImage8 from '../../../assets/images/about/buyers/mom.png';
import buyerImage9 from '../../../assets/images/about/buyers/pcc.png';
import buyerImage10 from '../../../assets/images/about/buyers/walmart.png';
import buyerImage11 from '../../../assets/images/about/buyers/wholeFoods.png';

export const DEFAULT_BUYER_IMAGES = [
	buyerImage1,
	buyerImage2,
	buyerImage3,
	buyerImage4,
	buyerImage5,
	buyerImage6,
	buyerImage7,
	buyerImage8,
	buyerImage9,
	buyerImage10,
	buyerImage11
];

export const DEFAULT_BUYER_LABELS = {
	title: 'Be Seen By Buyers From:'
};
